import { SET_ACTIVE_ROUTE } from "./constants";

export const setActiveRoute = route => ({
  type: SET_ACTIVE_ROUTE,
  route
});
